// 创建同步Action
export const createAction = (type: string) => {
    return (payload?: any): Action.Sync => ({
        type,
        payload
    });
};

// 创建异步Action
export const createAsyncAction = (type: string) => {
    return {
        init: (payload?: Object, callback?: Action.AsyncCallback): Action.Async => ({
            type,
            payload,
            callback
        }),
        succeeded: (payload?: Object, callback?: Action.AsyncCallback): Action.Async => ({
            type: `${type}_SUCCEEDED`,
            payload,
            callback
        }),
        failed: (payload?: Object, callback?: Action.AsyncCallback): Action.Async => ({
            type: `${type}_FAILED`,
            payload,
            callback
        })
    };
};
